<template>
  <div
    class="checkout-summary"
  >
    <OnboardingModal
      v-if="showModal"
      size="lg"
      :body="modalBody"
      @submitAnswer="openPharmSelect"
    />

    <SideModal
      v-if="!isOnboardingRedesign"
      :show="showEditModal"
      :show-close="true"
      body-class="terms-body"
      @exit="showEditModal = false"
    >
      <template #body>
        <h2 class="question-title with-subtext">
          Edit your prescribed treatments
        </h2>
        <h3 class="sub-text mb-6">
          Change of mind? Here are the recommended treatments:
        </h3>
        <EditCheckout
          :desired-plan="desiredPlan"
          :product-reveal="productreveal"
          :treatment-form="treatmentform"
          @close-edit="showEditModal = false"
          @update-checkout="
            getProductReveal();
            $emit('reload-summary');
            showEditModal = false;
          "
          @get-product-reveal="getProductReveal"
        />
      </template>
    </SideModal>
    <div
      class="bg-overlay"
      @click="showEditModal = false"
    ></div>

    <SideModal
      :show="riskModal"
      header-class="terms-title tw-px-8"
      body-class="terms-body"
      :full-width="isOnboardingRedesign ? true : false"
      @exit="hideRiskModal()"
    >
      <template #header>
        <template v-if="!isOnboardingRedesign">
          <h1 class="h2 mb-0 heading text-primary">
            Safety Information
          </h1>
        </template>
      </template>
      <template #body>
        <div
          v-if="isOnboardingRedesign"
          class="tw-max-w-[700px] tw-mx-auto tw-mb-6"
        >
          <p class="tw-text-[#787878] tw-text-lg tw-mb-0">
            Safety Information
          </p>
        </div>
        <Risk :class="{'tw-pb-[300px] tw-max-w-[700px] tw-mx-auto': isOnboardingRedesign}" />
        <b-row>
          <b-col
            cols="12"
            :class="isOnboardingRedesign ? 'tw-text-center tw-my-8 tw-fixed tw-bg-white -tw-bottom-8 tw-left-0 tw-right-0 tw-px-4' : 'text-right'"
          >
            <b-button
              class="slight-rounded"
              :class="isOnboardingRedesign ? 'tw-my-4' : ''"
              pill
              variant="info"
              style="min-width: 250px"
              :disabled="loading"
              @click="agreeTerms()"
            >
              {{ isOnboardingRedesign ? 'I Understand' : 'I Agree' }}
            </b-button>
          </b-col>
        </b-row>
      </template>
    </SideModal>
    <div
      class="bg-overlay"
      @click="hideRiskModal()"
    ></div>

    <div
      v-if="
        !nonrx && body.hasOwnProperty('desiredplan') && desiredPlan.length > 0
      "
    >
      <template v-if="isOnboardingRedesign">
        <template v-if="['E1', 'F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)">
          <DoctorHeader>
            You’re almost done!
          </DoctorHeader>
          <h3 class="sub-text tw-leading-[20px] tw-text-[20px] md:tw-text-2xl tw-mt-8">
            Review your treatment selections and make any necessary changes.
          </h3>
        </template>
        <template v-else>
          <h2 class="question-title with-subtext">
            You’re almost done!
          </h2>
          <h3 class="sub-text mb-5 tw-leading-[20px] tw-text-lg md:tw-text-2xl md:tw-text-[#787878] lg:tw-text-[#1A1A1A] lg:tw-text-lg">
            Review your treatment selections and make any necessary changes. At the next step, you’ll add billing and shipping information for when the doctor reviews and fulfills your prescriptions.
          </h3>
        </template>
      </template>
      <template v-else>
        <h2 class="question-title with-subtext">
          Your visit summary
        </h2>
        <h3 class="sub-text mb-5">
          Almost done! Here’s your personalized treatment plan for the doctor to
          review. Our board certified doctors are here to determine the right
          treatment plan for you. In the next step, you’ll add billing information
          to your account and then a Winona doctor will review your medical
          history and address any questions.
        </h3>
      </template>

      <div class="d-flex justify-content-between">
        <h3
          class="sub-text mb-4"
          :class="{'!tw-text-lg': isOnboardingRedesign}"
          style="margin-top: 10px"
        >
          {{ isOnboardingRedesign ? 'Prescription(s)' : 'Prescription Treatment' }}
        </h3>
        <span
          class="sub-text mb-4"
          style="margin-top: 10px"
        >
          <template v-if="isOnboardingRedesign">
            <a
              v-if="!showEditCheckout"
              href="javascript:void(0)"
              :disabled="loading"
              style="color: #1a6a72"
              class="tw-text-sm md:tw-text-lg"
              @click="showEditCheckout = true"
            >
              <u>EDIT</u>
            </a>
            <a
              v-if="showEditCheckout"
              href="javascript:void(0)"
              :disabled="loading"
              style="color: #1a6a72"
              class="tw-text-sm md:tw-text-lg"
              :class="{ 'tw-pointer-events-none !tw-cursor-not-allowed tw-text-gray-400': showEditCheckout && !hasSelectedTreatment }"
              @click="() => onTreatmentEdit('link')"
            >
              <u>SAVE</u>
            </a>
          </template>
          <a
            v-else
            href="javascript:void(0)"
            :disabled="loading"
            style="color: #1a6a72"
            @click="showEditModal = true"
          >
            <u>EDIT</u>
          </a>
        </span>
      </div>

      <template v-if="isOnboardingRedesign">
        <EditCheckout
          v-if="showEditCheckout"
          ref="EditCheckout"
          :desired-plan="desiredPlan"
          :product-reveal="productreveal"
          :treatment-form="treatmentform"
          @close-edit="showEditModal = false"
          @update-checkout="
            $emit('reload-summary');
            showEditModal = false;
          "
          @get-product-reveal="getProductReveal"
          @has-selected-treatment="onHasSelectedTreatmentChange"
        />
        <template v-else>
          <b-card
            v-for="med in desiredPlan?.filter(
              (x) =>
                x.type === undefined || (x.type != undefined && x.type === 'RX')
            )"
            :key="med.id"
            no-body
            :style="isOnboardingRedesign ? '' : 'background-color: rgba(242, 242, 242, 0.5)'"
            :class="isOnboardingRedesign ? 'tw-p-3 tw-rounded-xl tw-border-[#C7C7C7]' : 'py-2'"
          >
            <b-row
              no-gutters
              align-v="stretch"
            >
              <template v-if="isOnboardingRedesign">
                <b-col
                  v-if="med.image"
                  cols="4"
                  class="p-0 tw-rounded-[4px]"
                  :class="[
                    ['C', 'D1'].includes(body.flow_variant) ? 'tw-bg-[#EAF4F5]' : 'tw-bg-[#DCD7EE]'
                  ]"
                >
                  <div
                    class="img-holder tw-h-[108px] md:!tw-h-[180px]"
                    :class="{'non-hrt': onboardingPatient?.non_hrt}"
                  >
                    <img
                      class="tw-rounded-lg"
                      :src="med.image"
                      :alt="med.name"
                    >
                  </div>
                </b-col>
              </template>
              <b-col
                :cols="med.image ? '8' : '12'"
                class="d-flex flex-column justify-content-between pl-4 pr-2 h-100"
                align-self="center"
              >
                <div class="mb-2">
                  <h3
                    class="mb-2"
                    :class="isOnboardingRedesign ? 'tw-text-lg md:tw-text-2xl' : 'tw-text-xl med-font'"
                  >
                    {{ med.name }}
                  </h3>
                  <p
                    v-if="!(med.pricingdetail.nickname === 'One time payment' && onboardingPatient?.non_hrt)"
                    :class="{'tw-text-lg tw-text-[#787878] tw-m-0': isOnboardingRedesign}"
                  >
                    <template v-if="med.pricingdetail.nickname === 'Auto-refilled every 3 months'">
                      Ships every 3 months
                    </template>
                    <template v-else>
                      {{ med.pricingdetail.nickname }}
                    </template>
                  </p>
                </div>
                <p class="med-font mb-0">
                  <!-- med.pricingdetail.hidebillingfrequency -->
                  <span
                    v-if="med.pricingdetail.hasOwnProperty('hidebillingfrequency')"
                    :class="isOnboardingRedesign && 'tw-text-lg'"
                  >
                    ${{ med.price }}
                  </span>
                  <span
                    v-else
                    :class="isOnboardingRedesign && 'tw-text-lg'"
                  >
                    {{
                      formatPricing(
                        med.pricingdetail.type,
                        med.price,
                        med.pricingdetail.recurring,
                      )
                    }}
                  </span>
                </p>
              </b-col>
              <!-- this is for image placeholder  -->
              <template v-if="!isOnboardingRedesign">
                <b-col
                  v-if="med.image"
                  cols="4"
                  class="p-0"
                >
                  <div
                    class="img-holder"
                    :class="{'non-hrt': onboardingPatient?.non_hrt}"
                  >
                    <img
                      :src="med.image"
                      :alt="med.name"
                    >
                  </div>
                </b-col>
              </template>
            </b-row>
          </b-card>
        </template>
      </template>

      <template v-else>
        <b-card
          v-for="med in desiredPlan?.filter(
            (x) =>
              x.type === undefined || (x.type != undefined && x.type === 'RX')
          )"
          :key="med.id"
          no-body
          :style="isOnboardingRedesign ? '' : 'background-color: rgba(242, 242, 242, 0.5)'"
          :class="isOnboardingRedesign ? 'tw-p-3 tw-rounded-xl tw-border-[#C7C7C7]' : 'py-2'"
        >
          <b-row
            no-gutters
            align-v="stretch"
          >
            <template v-if="isOnboardingRedesign">
              <b-col
                v-if="med.image"
                cols="4"
                class="p-0"
              >
                <div
                  class="img-holder"
                  :class="{'non-hrt': onboardingPatient?.non_hrt}"
                >
                  <img
                    class="tw-rounded-lg"
                    :src="med.image"
                    :alt="med.name"
                  >
                </div>
              </b-col>
            </template>
            <b-col
              :cols="med.image ? '8' : '12'"
              class="d-flex flex-column justify-content-between pl-4 pr-2 h-100"
              align-self="center"
            >
              <div class="mb-4">
                <h3
                  class="mb-2 tw-text-xl"
                  :class="isOnboardingRedesign ? 'tw-text-xl' : 'med-font'"
                >
                  {{ med.name }}
                </h3>
                <p :class="{'tw-text-md tw-text-[#787878]': isOnboardingRedesign}">
                  {{ med.pricingdetail.nickname }}
                </p>
              </div>
              <p class="med-font mb-0">
                <!-- med.pricingdetail.hidebillingfrequency -->
                <span
                  v-if="med.pricingdetail.hasOwnProperty('hidebillingfrequency')"
                >
                  ${{ med.price }}
                </span>
                <span v-else>
                  {{
                    formatPricing(
                      med.pricingdetail.type,
                      med.price,
                      med.pricingdetail.recurring
                    )
                  }}
                </span>
              </p>
            </b-col>
            <!-- this is for image placeholder  -->
            <template v-if="!isOnboardingRedesign">
              <b-col
                v-if="med.image"
                cols="4"
                class="p-0"
              >
                <div
                  class="img-holder"
                  :class="{'non-hrt': onboardingPatient?.non_hrt}"
                >
                  <img
                    :src="med.image"
                    :alt="med.name"
                  >
                </div>
              </b-col>
            </template>
          </b-row>
        </b-card>
      </template>

      <div
        v-if="isOnboardingRedesign"
        class="tw-space-y-2"
      >
        <div class="tw-flex tw-gap-2">
          <div class="tw-mt-1">
            <svg
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.52734 16.7969C7.40038 16.7969 6.33813 16.5812 5.34058 16.1498C4.34842 15.7184 3.4722 15.1226 2.7119 14.3623C1.95161 13.602 1.35578 12.7258 0.924403 11.7336C0.49303 10.7361 0.277344 9.67384 0.277344 8.54688C0.277344 7.41991 0.49303 6.36036 0.924403 5.3682C1.35578 4.37065 1.94891 3.49173 2.70381 2.73143C3.46411 1.97114 4.34033 1.37531 5.33249 0.943934C6.33004 0.512561 7.39229 0.296875 8.51926 0.296875C9.64622 0.296875 10.7085 0.512561 11.706 0.943934C12.7036 1.37531 13.5825 1.97114 14.3428 2.73143C15.1031 3.49173 15.6989 4.37065 16.1303 5.3682C16.5617 6.36036 16.7773 7.41991 16.7773 8.54688C16.7773 9.67384 16.5617 10.7361 16.1303 11.7336C15.6989 12.7258 15.1031 13.602 14.3428 14.3623C13.5825 15.1226 12.7036 15.7184 11.706 16.1498C10.7139 16.5812 9.6543 16.7969 8.52734 16.7969ZM8.52734 15.4219C9.48176 15.4219 10.3742 15.2439 11.2045 14.8881C12.0349 14.5322 12.7656 14.0415 13.3965 13.416C14.0273 12.7851 14.518 12.0545 14.8685 11.2241C15.2244 10.3937 15.4023 9.50129 15.4023 8.54688C15.4023 7.59246 15.2244 6.70006 14.8685 5.86967C14.5126 5.03928 14.0193 4.30864 13.3884 3.67776C12.7629 3.04688 12.0322 2.55619 11.1965 2.2057C10.3661 1.84982 9.47367 1.67188 8.51926 1.67188C7.56484 1.67188 6.67244 1.84982 5.84205 2.2057C5.01166 2.55619 4.28372 3.04688 3.65823 3.67776C3.03274 4.30864 2.54205 5.03928 2.18617 5.86967C1.83568 6.70006 1.66043 7.59246 1.66043 8.54688C1.66043 9.50129 1.83568 10.3937 2.18617 11.2241C2.54205 12.0545 3.03274 12.7851 3.65823 13.416C4.28911 14.0415 5.01975 14.5322 5.85014 14.8881C6.68053 15.2439 7.57293 15.4219 8.52734 15.4219ZM8.51926 10.0028C8.10406 10.0028 7.89107 9.78977 7.88029 9.36379L7.77514 5.08511C7.76975 4.88021 7.83445 4.71036 7.96926 4.57555C8.10945 4.44075 8.29009 4.37335 8.51117 4.37335C8.72685 4.37335 8.90479 4.44344 9.04499 4.58364C9.19058 4.71844 9.26068 4.8883 9.25529 5.0932L9.13396 9.36379C9.12857 9.78977 8.92367 10.0028 8.51926 10.0028ZM8.51926 12.6314C8.282 12.6314 8.0771 12.5506 7.90455 12.3888C7.732 12.2216 7.64573 12.0221 7.64573 11.7903C7.64573 11.5584 7.732 11.3616 7.90455 11.1998C8.0771 11.0327 8.282 10.9491 8.51926 10.9491C8.75651 10.9491 8.96141 11.03 9.13396 11.1917C9.30651 11.3535 9.39279 11.553 9.39279 11.7903C9.39279 12.0275 9.30381 12.227 9.12587 12.3888C8.95332 12.5506 8.75112 12.6314 8.51926 12.6314Z"
                fill="#1A6A72"
              />
            </svg>
          </div>
          <p class="tw-mb-0 tw-text-sm tw-leading-5 md:tw-text-[16px] lg:tw-text-lg lg:tw-leading-[22px]">
            You won't be charged until your doctor reviews the selected treatments and writes the prescription(s).
          </p>
        </div>
        <div class="tw-flex tw-gap-2">
          <div class="tw-mt-1">
            <svg
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.52734 16.7969C7.40038 16.7969 6.33813 16.5812 5.34058 16.1498C4.34842 15.7184 3.4722 15.1226 2.7119 14.3623C1.95161 13.602 1.35578 12.7258 0.924403 11.7336C0.49303 10.7361 0.277344 9.67384 0.277344 8.54688C0.277344 7.41991 0.49303 6.36036 0.924403 5.3682C1.35578 4.37065 1.94891 3.49173 2.70381 2.73143C3.46411 1.97114 4.34033 1.37531 5.33249 0.943934C6.33004 0.512561 7.39229 0.296875 8.51926 0.296875C9.64622 0.296875 10.7085 0.512561 11.706 0.943934C12.7036 1.37531 13.5825 1.97114 14.3428 2.73143C15.1031 3.49173 15.6989 4.37065 16.1303 5.3682C16.5617 6.36036 16.7773 7.41991 16.7773 8.54688C16.7773 9.67384 16.5617 10.7361 16.1303 11.7336C15.6989 12.7258 15.1031 13.602 14.3428 14.3623C13.5825 15.1226 12.7036 15.7184 11.706 16.1498C10.7139 16.5812 9.6543 16.7969 8.52734 16.7969ZM8.52734 15.4219C9.48176 15.4219 10.3742 15.2439 11.2045 14.8881C12.0349 14.5322 12.7656 14.0415 13.3965 13.416C14.0273 12.7851 14.518 12.0545 14.8685 11.2241C15.2244 10.3937 15.4023 9.50129 15.4023 8.54688C15.4023 7.59246 15.2244 6.70006 14.8685 5.86967C14.5126 5.03928 14.0193 4.30864 13.3884 3.67776C12.7629 3.04688 12.0322 2.55619 11.1965 2.2057C10.3661 1.84982 9.47367 1.67188 8.51926 1.67188C7.56484 1.67188 6.67244 1.84982 5.84205 2.2057C5.01166 2.55619 4.28372 3.04688 3.65823 3.67776C3.03274 4.30864 2.54205 5.03928 2.18617 5.86967C1.83568 6.70006 1.66043 7.59246 1.66043 8.54688C1.66043 9.50129 1.83568 10.3937 2.18617 11.2241C2.54205 12.0545 3.03274 12.7851 3.65823 13.416C4.28911 14.0415 5.01975 14.5322 5.85014 14.8881C6.68053 15.2439 7.57293 15.4219 8.52734 15.4219ZM8.51926 10.0028C8.10406 10.0028 7.89107 9.78977 7.88029 9.36379L7.77514 5.08511C7.76975 4.88021 7.83445 4.71036 7.96926 4.57555C8.10945 4.44075 8.29009 4.37335 8.51117 4.37335C8.72685 4.37335 8.90479 4.44344 9.04499 4.58364C9.19058 4.71844 9.26068 4.8883 9.25529 5.0932L9.13396 9.36379C9.12857 9.78977 8.92367 10.0028 8.51926 10.0028ZM8.51926 12.6314C8.282 12.6314 8.0771 12.5506 7.90455 12.3888C7.732 12.2216 7.64573 12.0221 7.64573 11.7903C7.64573 11.5584 7.732 11.3616 7.90455 11.1998C8.0771 11.0327 8.282 10.9491 8.51926 10.9491C8.75651 10.9491 8.96141 11.03 9.13396 11.1917C9.30651 11.3535 9.39279 11.553 9.39279 11.7903C9.39279 12.0275 9.30381 12.227 9.12587 12.3888C8.95332 12.5506 8.75112 12.6314 8.51926 12.6314Z"
                fill="#1A6A72"
              />
            </svg>
          </div>
          <p class="tw-mb-0 tw-text-sm tw-leading-5 md:tw-text-[16px] lg:tw-text-lg lg:tw-leading-[22px">
            You can easily change or cancel your subscription at any time from your Patient Portal.
          </p>
        </div>
      </div>
      <p
        v-else
        class="mb-5 pb-3"
        style="margin-top: -10px"
      >
        You won't be charged for or shipped this prescription product unless a
        doctor prescribes it to you.
      </p>
    </div>

    <template v-if="isOnboardingRedesign">
      <h3 class="tw-mt-6 tw-text-2xl">
        Benefits Exclusive to Winona
      </h3>
      <div>
        <div class="tw-flex tw-gap-2">
          <svg
            width="22"
            height="17"
            viewBox="0 0 22 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.533203 3.82436C0.533203 2.98351 0.747041 2.34762 1.17472 1.91668C1.60239 1.48049 2.23308 1.26239 3.06678 1.26239H3.89506V2.59462H3.00993C2.64181 2.59462 2.36571 2.69973 2.18165 2.90994C1.99759 3.1149 1.90555 3.41182 1.90555 3.80072C1.90555 4.27895 1.98676 4.79923 2.14917 5.36155C2.31699 5.92387 2.54707 6.48619 2.8394 7.04851C3.13174 7.61083 3.46468 8.12585 3.83822 8.59357C4.21717 9.05604 4.61778 9.42917 5.04004 9.71296C5.4623 9.99149 5.88727 10.1308 6.31495 10.1308C6.74262 10.1308 7.16759 9.99149 7.58985 9.71296C8.01211 9.42917 8.41002 9.05604 8.78356 8.59357C9.15709 8.12585 9.49003 7.61083 9.78237 7.04851C10.0747 6.48619 10.3048 5.92387 10.4726 5.36155C10.6404 4.79923 10.7243 4.27895 10.7243 3.80072C10.7243 3.41182 10.6323 3.1149 10.4482 2.90994C10.2642 2.69973 9.98808 2.59462 9.61996 2.59462H8.73483V1.26239H9.555C10.3941 1.26239 11.0248 1.48049 11.4471 1.91668C11.8747 2.34762 12.0886 2.98351 12.0886 3.82436C12.0886 4.44449 11.9803 5.10404 11.7638 5.80299C11.5526 6.4967 11.2603 7.17989 10.8867 7.85257C10.5186 8.52 10.0964 9.12699 9.61996 9.67354C9.14356 10.2148 8.63739 10.6484 8.10144 10.9742C7.56549 11.2948 7.02684 11.4551 6.48547 11.4551H6.1363C5.60035 11.4551 5.0644 11.2948 4.52845 10.9742C3.9925 10.6484 3.48362 10.2148 3.00181 9.67354C2.52541 9.12699 2.10045 8.52 1.72691 7.85257C1.35878 7.17989 1.06644 6.4967 0.8499 5.80299C0.638769 5.10404 0.533203 4.44449 0.533203 3.82436ZM9.58748 17.0047C8.30986 17.0047 7.32459 16.4739 6.63164 15.4124C5.94411 14.356 5.60306 12.8372 5.60847 10.856H6.98082C6.96999 12.4011 7.18383 13.5914 7.62233 14.427C8.06625 15.2626 8.70235 15.6804 9.53063 15.6804C9.97455 15.6804 10.3562 15.5832 10.6756 15.3887C11.0004 15.1995 11.2738 14.9157 11.4958 14.5373C11.7231 14.1642 11.918 13.7017 12.0804 13.1499C12.2429 12.5981 12.389 11.9596 12.519 11.2344C12.7138 10.157 12.9683 9.28727 13.2823 8.6251C13.5963 7.96293 13.9806 7.48207 14.4354 7.18252C14.8955 6.88296 15.445 6.73319 16.0838 6.73319C16.793 6.73319 17.3804 6.92238 17.8459 7.30076C18.3169 7.67389 18.6796 8.24146 18.9341 9.00349C19.1885 9.76025 19.3536 10.7167 19.4294 11.8729H18.0652C18.0327 11.011 17.9407 10.2989 17.7891 9.7366C17.6375 9.16903 17.4183 8.74598 17.1314 8.46744C16.8498 8.18891 16.498 8.04964 16.0757 8.04964C15.7184 8.04964 15.399 8.15738 15.1175 8.37285C14.8414 8.58832 14.6005 8.95093 14.3948 9.4607C14.1891 9.96521 14.0104 10.6615 13.8588 11.5497C13.6477 12.7637 13.3608 13.7753 12.9981 14.5846C12.6408 15.394 12.1833 15.9983 11.6257 16.3977C11.0681 16.8024 10.3887 17.0047 9.58748 17.0047ZM4.26048 3.09125C3.92483 3.09125 3.63791 2.97826 3.39971 2.75228C3.16693 2.52104 3.05053 2.24251 3.05053 1.91668C3.05053 1.59611 3.16693 1.32283 3.39971 1.09685C3.63791 0.865617 3.92483 0.75 4.26048 0.75C4.59071 0.75 4.87492 0.865617 5.11312 1.09685C5.35132 1.32283 5.47042 1.59611 5.47042 1.91668C5.47042 2.24251 5.35132 2.52104 5.11312 2.75228C4.87492 2.97826 4.59071 3.09125 4.26048 3.09125ZM8.35317 3.09125C8.02294 3.09125 7.73873 2.97826 7.50053 2.75228C7.26233 2.52104 7.14323 2.24251 7.14323 1.91668C7.14323 1.59611 7.26233 1.32283 7.50053 1.09685C7.73873 0.865617 8.02294 0.75 8.35317 0.75C8.6834 0.75 8.96762 0.865617 9.20582 1.09685C9.44402 1.32283 9.56312 1.59611 9.56312 1.91668C9.56312 2.24251 9.44402 2.52104 9.20582 2.75228C8.96762 2.97826 8.6834 3.09125 8.35317 3.09125ZM18.796 16.0272C18.3359 16.0272 17.9163 15.9169 17.5374 15.6961C17.1638 15.4807 16.8634 15.189 16.636 14.8211C16.414 14.4585 16.3031 14.0539 16.3031 13.6072C16.3031 13.1657 16.414 12.7637 16.636 12.4011C16.8634 12.0332 17.1638 11.7415 17.5374 11.526C17.9163 11.3106 18.3359 11.2028 18.796 11.2028C19.2508 11.2028 19.6649 11.3106 20.0385 11.526C20.4174 11.7415 20.7152 12.0332 20.9317 12.4011C21.1537 12.7637 21.2646 13.1657 21.2646 13.6072C21.2646 14.0539 21.1537 14.4585 20.9317 14.8211C20.7152 15.189 20.4174 15.4807 20.0385 15.6961C19.6649 15.9169 19.2508 16.0272 18.796 16.0272ZM18.796 14.8605C19.0342 14.8605 19.2481 14.8027 19.4376 14.6871C19.6324 14.5768 19.7867 14.427 19.9004 14.2378C20.0141 14.0486 20.0709 13.8384 20.0709 13.6072C20.0709 13.3759 20.0141 13.1657 19.9004 12.9765C19.7867 12.7873 19.6324 12.6402 19.4376 12.5351C19.2481 12.4247 19.0342 12.3695 18.796 12.3695C18.5578 12.3695 18.3413 12.4247 18.1464 12.5351C17.9515 12.6402 17.7945 12.7873 17.6754 12.9765C17.5617 13.1657 17.5049 13.3759 17.5049 13.6072C17.5049 13.8384 17.5617 14.0486 17.6754 14.2378C17.7945 14.427 17.9515 14.5768 18.1464 14.6871C18.3413 14.8027 18.5578 14.8605 18.796 14.8605Z"
              fill="#212121"
            />
          </svg>
          <p class="tw-mb-0 tw-text-lg">
            24/7 Support
          </p>
        </div>
        <p
          class="tw-text-[#787878] tw-text-sm tw-leading-5 md:tw-text-[16px] lg:tw-text-lg lg:tw-leading-[22px"
        >
          As a Winona patient, you’ll receive free, continuous, personalized care from your dedicated physician and our Patient Care Team.
        </p>
      </div>
      <div>
        <div class="tw-flex tw-gap-2">
          <svg
            width="22"
            height="17"
            viewBox="0 0 22 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.533203 3.82436C0.533203 2.98351 0.747041 2.34762 1.17472 1.91668C1.60239 1.48049 2.23308 1.26239 3.06678 1.26239H3.89506V2.59462H3.00993C2.64181 2.59462 2.36571 2.69973 2.18165 2.90994C1.99759 3.1149 1.90555 3.41182 1.90555 3.80072C1.90555 4.27895 1.98676 4.79923 2.14917 5.36155C2.31699 5.92387 2.54707 6.48619 2.8394 7.04851C3.13174 7.61083 3.46468 8.12585 3.83822 8.59357C4.21717 9.05604 4.61778 9.42917 5.04004 9.71296C5.4623 9.99149 5.88727 10.1308 6.31495 10.1308C6.74262 10.1308 7.16759 9.99149 7.58985 9.71296C8.01211 9.42917 8.41002 9.05604 8.78356 8.59357C9.15709 8.12585 9.49003 7.61083 9.78237 7.04851C10.0747 6.48619 10.3048 5.92387 10.4726 5.36155C10.6404 4.79923 10.7243 4.27895 10.7243 3.80072C10.7243 3.41182 10.6323 3.1149 10.4482 2.90994C10.2642 2.69973 9.98808 2.59462 9.61996 2.59462H8.73483V1.26239H9.555C10.3941 1.26239 11.0248 1.48049 11.4471 1.91668C11.8747 2.34762 12.0886 2.98351 12.0886 3.82436C12.0886 4.44449 11.9803 5.10404 11.7638 5.80299C11.5526 6.4967 11.2603 7.17989 10.8867 7.85257C10.5186 8.52 10.0964 9.12699 9.61996 9.67354C9.14356 10.2148 8.63739 10.6484 8.10144 10.9742C7.56549 11.2948 7.02684 11.4551 6.48547 11.4551H6.1363C5.60035 11.4551 5.0644 11.2948 4.52845 10.9742C3.9925 10.6484 3.48362 10.2148 3.00181 9.67354C2.52541 9.12699 2.10045 8.52 1.72691 7.85257C1.35878 7.17989 1.06644 6.4967 0.8499 5.80299C0.638769 5.10404 0.533203 4.44449 0.533203 3.82436ZM9.58748 17.0047C8.30986 17.0047 7.32459 16.4739 6.63164 15.4124C5.94411 14.356 5.60306 12.8372 5.60847 10.856H6.98082C6.96999 12.4011 7.18383 13.5914 7.62233 14.427C8.06625 15.2626 8.70235 15.6804 9.53063 15.6804C9.97455 15.6804 10.3562 15.5832 10.6756 15.3887C11.0004 15.1995 11.2738 14.9157 11.4958 14.5373C11.7231 14.1642 11.918 13.7017 12.0804 13.1499C12.2429 12.5981 12.389 11.9596 12.519 11.2344C12.7138 10.157 12.9683 9.28727 13.2823 8.6251C13.5963 7.96293 13.9806 7.48207 14.4354 7.18252C14.8955 6.88296 15.445 6.73319 16.0838 6.73319C16.793 6.73319 17.3804 6.92238 17.8459 7.30076C18.3169 7.67389 18.6796 8.24146 18.9341 9.00349C19.1885 9.76025 19.3536 10.7167 19.4294 11.8729H18.0652C18.0327 11.011 17.9407 10.2989 17.7891 9.7366C17.6375 9.16903 17.4183 8.74598 17.1314 8.46744C16.8498 8.18891 16.498 8.04964 16.0757 8.04964C15.7184 8.04964 15.399 8.15738 15.1175 8.37285C14.8414 8.58832 14.6005 8.95093 14.3948 9.4607C14.1891 9.96521 14.0104 10.6615 13.8588 11.5497C13.6477 12.7637 13.3608 13.7753 12.9981 14.5846C12.6408 15.394 12.1833 15.9983 11.6257 16.3977C11.0681 16.8024 10.3887 17.0047 9.58748 17.0047ZM4.26048 3.09125C3.92483 3.09125 3.63791 2.97826 3.39971 2.75228C3.16693 2.52104 3.05053 2.24251 3.05053 1.91668C3.05053 1.59611 3.16693 1.32283 3.39971 1.09685C3.63791 0.865617 3.92483 0.75 4.26048 0.75C4.59071 0.75 4.87492 0.865617 5.11312 1.09685C5.35132 1.32283 5.47042 1.59611 5.47042 1.91668C5.47042 2.24251 5.35132 2.52104 5.11312 2.75228C4.87492 2.97826 4.59071 3.09125 4.26048 3.09125ZM8.35317 3.09125C8.02294 3.09125 7.73873 2.97826 7.50053 2.75228C7.26233 2.52104 7.14323 2.24251 7.14323 1.91668C7.14323 1.59611 7.26233 1.32283 7.50053 1.09685C7.73873 0.865617 8.02294 0.75 8.35317 0.75C8.6834 0.75 8.96762 0.865617 9.20582 1.09685C9.44402 1.32283 9.56312 1.59611 9.56312 1.91668C9.56312 2.24251 9.44402 2.52104 9.20582 2.75228C8.96762 2.97826 8.6834 3.09125 8.35317 3.09125ZM18.796 16.0272C18.3359 16.0272 17.9163 15.9169 17.5374 15.6961C17.1638 15.4807 16.8634 15.189 16.636 14.8211C16.414 14.4585 16.3031 14.0539 16.3031 13.6072C16.3031 13.1657 16.414 12.7637 16.636 12.4011C16.8634 12.0332 17.1638 11.7415 17.5374 11.526C17.9163 11.3106 18.3359 11.2028 18.796 11.2028C19.2508 11.2028 19.6649 11.3106 20.0385 11.526C20.4174 11.7415 20.7152 12.0332 20.9317 12.4011C21.1537 12.7637 21.2646 13.1657 21.2646 13.6072C21.2646 14.0539 21.1537 14.4585 20.9317 14.8211C20.7152 15.189 20.4174 15.4807 20.0385 15.6961C19.6649 15.9169 19.2508 16.0272 18.796 16.0272ZM18.796 14.8605C19.0342 14.8605 19.2481 14.8027 19.4376 14.6871C19.6324 14.5768 19.7867 14.427 19.9004 14.2378C20.0141 14.0486 20.0709 13.8384 20.0709 13.6072C20.0709 13.3759 20.0141 13.1657 19.9004 12.9765C19.7867 12.7873 19.6324 12.6402 19.4376 12.5351C19.2481 12.4247 19.0342 12.3695 18.796 12.3695C18.5578 12.3695 18.3413 12.4247 18.1464 12.5351C17.9515 12.6402 17.7945 12.7873 17.6754 12.9765C17.5617 13.1657 17.5049 13.3759 17.5049 13.6072C17.5049 13.8384 17.5617 14.0486 17.6754 14.2378C17.7945 14.427 17.9515 14.5768 18.1464 14.6871C18.3413 14.8027 18.5578 14.8605 18.796 14.8605Z"
              fill="#212121"
            />
          </svg>
          <p class="tw-mb-0 tw-text-lg">
            Community Access
          </p>
        </div>
        <p
          class="tw-text-[#787878] tw-text-sm tw-leading-5 md:tw-text-[16px] lg:tw-text-lg lg:tw-leading-[22px"
        >
          Gain access to virtual and in-person community, live Q&As, and ongoing educational resources.
        </p>
      </div>
      <div>
        <div class="tw-flex tw-gap-2">
          <svg
            width="17"
            height="18"
            viewBox="0 0 17 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.02302 14.1162C1.67397 13.9136 1.40937 13.6856 1.22921 13.4322C1.04906 13.1732 0.958984 12.7763 0.958984 12.2415V5.8151C0.958984 5.4379 1.03217 5.12264 1.17855 4.86929C1.33055 4.61595 1.56137 4.39921 1.87101 4.21905L7.63874 0.950956C8.08912 0.691985 8.53669 0.5625 8.98145 0.5625C9.4262 0.5625 9.87377 0.691985 10.3242 0.950956L16.1003 4.21905C16.41 4.39921 16.638 4.61595 16.7843 4.86929C16.9307 5.12264 17.0039 5.4379 17.0039 5.8151V12.2415C17.0039 12.7763 16.9166 13.1732 16.7421 13.4322C16.5676 13.6856 16.303 13.9136 15.9483 14.1162L9.63169 17.6799C9.4065 17.8038 9.18975 17.8657 8.98145 17.8657C8.77314 17.8657 8.56203 17.8038 8.34809 17.6799L2.02302 14.1162ZM2.69015 13.1704L8.41565 16.4047V9.64899L2.06524 6.06V12.1993C2.06524 12.4245 2.11028 12.6103 2.20035 12.7566C2.29043 12.8974 2.4537 13.0353 2.69015 13.1704ZM15.2727 13.1704C15.5148 13.0353 15.6809 12.8974 15.771 12.7566C15.8611 12.6103 15.9061 12.4245 15.9061 12.1993V6.06L9.55569 9.64899V16.4047L15.2727 13.1704ZM8.98145 8.63563L11.5993 7.16625L5.28267 3.60259L2.67326 5.08886L8.98145 8.63563ZM12.7647 6.50757L15.2896 5.08886L9.82592 1.98121C9.27419 1.65468 8.71122 1.65468 8.13698 1.98121L6.43115 2.95235L12.7647 6.50757Z"
              fill="#212121"
            />
          </svg>
          <p class="tw-mb-0 tw-text-lg">
            Free Shipping
          </p>
        </div>
        <p
          class="tw-text-[#787878] tw-text-sm tw-leading-5 md:tw-text-[16px] lg:tw-text-lg lg:tw-leading-[22px]"
        >
          We offer fast and free shipping so you always have your medication when you need it.
        </p>
      </div>
    </template>
    <template v-else>
      <h3 class="mt-5 sub-text med-font">
        Added Benefits
      </h3>
      <b-row>
        <b-col
          cols="3"
          md="auto"
        >
          <img src="@/assets/images/onboarding/shipping.svg">
        </b-col>
        <b-col
          cols="9"
          class="pt-3 pr-0"
        >
          <h4 class="med-font">
            Free Shipping
          </h4>
          <p class="mb-0">
            We offer fast shipping so you have your medication when you need it.
          </p>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col
          cols="3"
          md="auto"
        >
          <img src="@/assets/images/onboarding/support.svg">
        </b-col>
        <b-col
          cols="9"
          class="pt-3 pr-0"
        >
          <h4 class="med-font">
            Continued Support
          </h4>
          <p class="mb-0">
            As a Winona patient, you will receive continuous, personalized care
            from our healthcare team who are specially trained to treat your
            symptoms.
          </p>
        </b-col>
      </b-row>
    </template>

    <div
      v-if="isOnboardingRedesign"
      class="mt-5 tw-bg-[#E7F0F1] tw-p-4 tw-rounded-xl tw-mb-20"
    >
      <p class="tw-mb-2 tw-text-lg lg:tw-text-2xl tw-leading-5">
        Please acknowledge you have read the safety information to continue:
      </p>
      <b-form-checkbox
        id="risk"
        v-model="risk"
        name="checkbox-2"
        class="tw-text-sm safety-info-checkbox"
      >
        <div class="tw-mt-0.5 tw-text-sm tw-leading-5 md:tw-text-[16px] lg:tw-text-lg lg:tw-leading-[22px]">
          <span>I have read and understand the&nbsp;</span>
          <a
            href="javascript:void(0)"
            class="text-underline"
            @click="showRiskModal()"
          >safety information</a>
          associated with these treatments.
        </div>
      </b-form-checkbox>
    </div>
    <div
      v-else
      class="mt-5"
    >
      <b-form-checkbox
        id="risk"
        v-model="risk"
        name="checkbox-2"
        class="tw-text-sm"
      >
        <div class="tw-mt-0.5">
          <span>I have read and understand the </span>
          <a
            href="javascript:void(0)"
            class="text-underline"
            @click="showRiskModal()"
          >Safety Information</a>
          associated with these treatments.
        </div>
      </b-form-checkbox>
    </div>

    <OnboardingCTAContainer>
      <div class="tw-w-full tw-flex tw-flex-col tw-gap-2">
        <div>
          <b-button
            pill
            block
            variant="info"
            class="slight-rounded"
            :class="{'tw-max-w-[300px] tw-mx-auto tw-text-base md:tw-text-lg': isOnboardingRedesign}"
            :disabled="isOnboardingRedesign ? buttonDisabled || isProcessing || (showEditCheckout && !hasSelectedTreatment) : buttonDisabled"
            @click="isOnboardingRedesign && showEditCheckout ? onTreatmentEdit() : confirmContinue()"
          >
            {{ loading ? "Loading" : !saving ? "Continue" : "Saving" }}
          </b-button>
        </div>
      </div>
    </OnboardingCTAContainer>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// libs
import _kebabCase from 'lodash/kebabCase'

// components
import OnboardingCTAContainer from '@/components/onboarding/OnboardingCTAContainer';
import Risk from '@/components/partials/Risk';
import SideModal from '@/components/partials/SideModal';
import EditCheckout from '@/components/onboarding/checkout/EditCheckout';
import OnboardingModal from '@/components/onboarding/questions/Modal';

// services
import { OnboardingService } from '@/services/onboarding.service.js';

// mixins
import analyticsMixin from '@/mixins/analytics';
import DoctorHeader from '@/components/partials/DoctorHeader.vue';

export default {
  components: {
    DoctorHeader,
    OnboardingCTAContainer,
    OnboardingModal,
    Risk,
    SideModal,
    EditCheckout,
  },
  mixins: [analyticsMixin],
  props: {
    body: {
      type: Object,
      default: () => ({}),
    },
    nonrx: {
      type: Boolean,
      default: false,
    },
    pharmacy: {
      type: Object,
      default: () => ({}),
    },
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    onboardingflow: {
      type: String,
      default: 'flowA',
    },
    analyticsId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      desiredAddon: [],
      desiredPlan: [],
      productreveal: [],
      loading: false,
      showModal: false,
      riskModal: false,
      treatmentform: '',
      risk: this.pharmacy.Risk,
      showEditModal: false,
      modalBody: {
        title: 'Need an alternate pharmacy?',
        description:
          'If you pick a pharmacy outside of the Winona Pharmacy Network and qualify for a prescription, you will be charged $50 for the platform fee and we will not be able to guarantee the price of the medication and provide free monthly delivery.',
        answerlist: [
          {
            id: 'winonaPharm',
            name: 'No, pick Winona Pharmacy',
          },
          {
            id: 'other',
            name: 'Yes, I\'m sure',
          },
        ],
      },
      showEditCheckout: false,
      hasSelectedTreatment: false,
      isProcessing: false
    };
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    ...mapState('onboarding', ['onboardingPatient']),
    onboardingVariant() {
      return this.onboardingPatient?.flow_variant;
    },
  },
  watch: {
    body() {
      console.log('body changed', this.body);
      this.desiredPlan = [];
      this.loading = true;
      this.desiredAddon = this.body.desiredaddon;
      this.risk = this.body.agreedtorisks;

      const _desiredPlan = [];
      if ('desiredplan' in this.body) {
        for (const med of this.body.desiredplan) {
          const found = this.body.desiredaddon?.filter(
            item => item.productid === med.productid
          );

          if (!found?.length) {
            _desiredPlan.push(med);
          }
        }
      }
      this.$set(this, 'desiredPlan', _desiredPlan);
      this.loading = false;
      this.treatmentform = this.body.treatmentform;
    },
    showEditModal() {
      const htmlTag = document.documentElement;
      if (this.showEditModal) {
        htmlTag.style.overflow = 'hidden';
      } else {
        htmlTag.style.overflow = null;
      }
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch(
        'onboarding/getPatientOnboarding'
      );
      if (!this.onboardingPatient?.non_hrt) {
        this.$emit('showLoader', 5, 'doctorvisit');
      }  

      if (this.body.onboardingstep === 5.4) {
        await this.$_analytics_track(
          'Verification Complete'
        )

        await OnboardingService.triggerOnboardingEvents({
          eventname: 'verificationComplete',
          path: window.location.pathname,
        })      
      }

      await this.getProductReveal();
      
      this.loading = true;
      this.desiredAddon = this.body.desiredaddon;
      this.risk = this.body.agreedtorisks;
      const _desiredPlan = [];
      if ('desiredplan' in this.body) {
        for (const med of this.body.desiredplan) {
          const found = this.body.desiredaddon?.filter(
            item => item.productid === med.productid
          );

          if (!found?.length) {
            _desiredPlan.push(med);
          }
        }
      }
      this.$set(this, 'desiredPlan', _desiredPlan);

      this.treatmentform = this.body.treatmentform;
      this.loading = false;
    } finally {
      this.loading = false;
    }
  },
  methods: {
    onHasSelectedTreatmentChange(val) {
      this.hasSelectedTreatment = val
    },
    async confirmContinue() {
      if (this.body.onboardingstep == 5.4) {
        // WIN-53617
        let products = {};
        if ('desiredplan' in this.body && this.body.desiredplan.length > 0) {
          console.log(this.body.desiredplan, this.productreveal)
          products = {
            products: this.body.desiredplan
              .filter(plan => plan.pricingdetail && plan.pricingdetail.pricingid)
              .map(plan => {
                const productObj = this.productreveal.find(product => plan.productid === product.id)
                return {
                  name: productObj?.previousproductname || productObj.name,
                  product_id: productObj.id,
                  category: 'core_products',
                  sku: productObj.id,
                  price: productObj.availablepricing.find(pricing => pricing.pricingid === plan.pricingdetail.pricingid).price,
                  url: `${process.env.VUE_APP_WEBSITE_URL}/product/${_kebabCase(productObj.name)}`,
                  image_url: productObj.image,
                }
              }),
          }
        }

        await this.$_analytics_track('Checkout Started', {
          customerId: this.analyticsId,
          onboardingflow: this.onboardingflow,
          email: this.body.email,
          phoneno: this.body.phoneno,
          state: this.body.state,
          firstname: this.body.firstname,
          lastname: this.body.lastname,
          ...products,
          currency: 'USD',
        });

        // GTM productObj
        const productObj = [];
        for (const item of this.desiredPlan) {
          const toPush = {
            id: item.productid,
            name: item.name,
            price: item.price,
          }
          productObj.push(toPush);
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          productObj: productObj
        });
      }

      if (this.risk) {
        this.$emit('nextStep');
      } else {
        this.elementTag('hidden', true);
      }
    },
    async getProductReveal() {
      this.productreveal = await this.$store.dispatch(
        'onboarding/getProductReveal'
      );
      
      if (this.productreveal && this.productreveal.length === 1) {
        const product = this.productreveal[0];
        const isAlreadySelected = this.body.desiredplan?.some(
          plan => plan.productid === product.id
        );
        
        if (!isAlreadySelected) {
          if (!this.body.desiredplan) {
            this.body.desiredplan = [];
          }
          this.body.desiredplan.push({
            productid: product.id,
            pricingid: product.availablepricing[0].pricingid
          });
        }
      }
    },
    openPharmSelect(_questionid = null, answer = null) {
      if (answer == 'winonaPharm') {
        this.$emit('clearPharmacy');
        return;
      }
      this.$emit('goToStep', 'pharmacy-select');
    },
    formatPricing(type, price, recurring) {
      let priceString = price
      if (this.isOnboardingRedesign) {
        const [dollars, cents] = price.toString().split('.');
        priceString = cents === '00' ? dollars : price.toFixed(2);
      }

      if (type == 'one_time') {
        if (this.onboardingPatient?.non_hrt) {
          return `$${price} per order`;
        } else {
          return `One time payment of $${price}`;
        }
      } else if (recurring.interval == 'day') {
        const isMoreThanOneMonth = recurring.interval_count / 30 > 1;
        const plural = isMoreThanOneMonth ? 's' : '';
        const interval = isMoreThanOneMonth
          ? Math.ceil(recurring.interval_count / 30) + ' '
          : '';
        return `$${priceString}/${interval}month${plural}`;
      } else {
        return `$${priceString}/${recurring.interval_count}${recurring.interval}(s)`;
      }
    },
    agreeTerms() {
      this.loading = true;
      this.risk = true;
      this.elementTag(null, false);

      if (this.isOnboardingRedesign) {
        this.confirmContinue();
      }
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    showRiskModal() {
      this.elementTag('hidden', true);
    },
    hideRiskModal() {
      this.elementTag(null, false);
    },
    elementTag(style, Boolean) {
      this.riskModal = Boolean;
      const htmlTag = document.documentElement;
      htmlTag.style.overflow = style;
      htmlTag.scrollTop = htmlTag.scrollHeight;
    },
    async onTreatmentEdit(type) {
      if (type === 'link') {
        this.isProcessing = true
        this.showEditCheckout = await this.$refs.EditCheckout.submitAnswer();
        this.isProcessing = false
        await this.getProductReveal();
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      } else {
        this.isProcessing = true
        this.showEditCheckout = await this.$refs.EditCheckout.submitAnswer()
        this.isProcessing = false
        await this.getProductReveal();
        if (this.risk) {
          this.confirmContinue();
        } else {
          this.showRiskModal()
        }
      }
    }
  },
};
</script>

<style scoped>
a.disabled {
  pointer-events: none;
}

::v-deep .modal-header {
  border-bottom: 0;
  align-items: center;
}

::v-deep .modal-footer {
  border-top: 0;
  align-items: center;
}

::v-deep .terms-modal .modal-header {
  padding-left: 10px;
  padding-right: 10px;
  font-family: "hattonmedium";
  letter-spacing: initial;
}
</style>

<style lang="scss" scoped>
.changePharmacy {
  color: #828282;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: $info;
  }
}
.selectPharmacy {
  color: #19191c;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: lighten(#19191c, 25%);
  }
}

.img-holder {
  width: 100% !important;
  height: 140px;
  text-align: right;
  margin-right: 0 !important;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.img-holder.non-hrt {
  img {
    object-fit: cover;
  }
}

.redesign {
  .safety-info-checkbox{
    ::v-deep label:before,
    ::v-deep label:after
    {
      top: 3px !important;
    }
  }
}
</style>
